// client/src/pages/PTO/StatsBar.tsx
// Horizontal stats bar showing today's date, out count, pending approvals, and action buttons.

import React from 'react';
import { Plus, Download, RefreshCw } from 'lucide-react';

interface StatsBarProps {
  todayOutCount: number;
  pendingCount: number;
  onNewEntry: () => void;
  onExport: () => void;
  onRefresh: () => void;
}

export default function StatsBar({
  todayOutCount,
  pendingCount,
  onNewEntry,
  onExport,
  onRefresh,
}: StatsBarProps) {
  const today = new Date();
  const dateStr = today.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });

  const outColor =
    todayOutCount === 0
      ? 'var(--good)'
      : todayOutCount <= 2
      ? 'var(--warn)'
      : 'var(--bad)';

  return (
    <div
      className="card"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 24,
        padding: '14px 18px',
        flexWrap: 'wrap',
      }}
    >
      {/* Today's date */}
      <div style={{ flex: '1 1 auto', minWidth: 200 }}>
        <div className="muted" style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: '.5px' }}>
          Today
        </div>
        <div style={{ fontSize: 15, fontWeight: 600, marginTop: 2 }}>{dateStr}</div>
      </div>

      {/* Out today */}
      <div style={{ textAlign: 'center', minWidth: 90 }}>
        <div className="muted" style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: '.5px' }}>
          Out Today
        </div>
        <div style={{ fontSize: 22, fontWeight: 700, color: outColor, marginTop: 2 }}>
          {todayOutCount}
        </div>
      </div>

      {/* Pending approvals */}
      {pendingCount > 0 && (
        <div style={{ textAlign: 'center', minWidth: 90 }}>
          <div className="muted" style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: '.5px' }}>
            Pending
          </div>
          <div style={{ fontSize: 22, fontWeight: 700, color: 'var(--warn)', marginTop: 2 }}>
            {pendingCount}
          </div>
        </div>
      )}

      {/* Actions */}
      <div style={{ display: 'flex', gap: 8, marginLeft: 'auto' }}>
        <button className="btn" onClick={onRefresh} title="Refresh data">
          <RefreshCw size={15} />
        </button>
        <button className="btn" onClick={onExport} title="Export">
          <Download size={15} />
          <span>Export</span>
        </button>
        <button className="btn primary" onClick={onNewEntry}>
          <Plus size={15} />
          <span>New Entry</span>
        </button>
      </div>
    </div>
  );
}
